export interface FavoriteFile {
  userId: string;
  fileName: string;
  addedAt: string;
}

const STORAGE_KEY = 'user_favorites';

export function getFavorites(userId: string): string[] {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return [];
  
  const allFavorites: FavoriteFile[] = JSON.parse(stored);
  return allFavorites
    .filter(f => f.userId === userId)
    .map(f => f.fileName);
}

export function isFavorite(userId: string, fileName: string): boolean {
  const favorites = getFavorites(userId);
  return favorites.includes(fileName);
}

export function addFavorite(userId: string, fileName: string): void {
  const stored = localStorage.getItem(STORAGE_KEY);
  const allFavorites: FavoriteFile[] = stored ? JSON.parse(stored) : [];
  
  // Check if already exists
  const exists = allFavorites.some(
    f => f.userId === userId && f.fileName === fileName
  );
  
  if (!exists) {
    allFavorites.push({
      userId,
      fileName,
      addedAt: new Date().toISOString()
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(allFavorites));
  }
}

export function removeFavorite(userId: string, fileName: string): void {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return;
  
  const allFavorites: FavoriteFile[] = JSON.parse(stored);
  const updated = allFavorites.filter(
    f => !(f.userId === userId && f.fileName === fileName)
  );
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}

export function toggleFavorite(userId: string, fileName: string): boolean {
  if (isFavorite(userId, fileName)) {
    removeFavorite(userId, fileName);
    return false;
  } else {
    addFavorite(userId, fileName);
    return true;
  }
}

/**
 * Update a favorite's stored path when its file is moved or renamed,
 * so it doesn't silently fall out of the favorites list.
 */
export function renameFavorite(userId: string, oldFileName: string, newFileName: string): void {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return;

  const allFavorites: FavoriteFile[] = JSON.parse(stored);
  const updated = allFavorites.map(f =>
    f.userId === userId && f.fileName === oldFileName
      ? { ...f, fileName: newFileName }
      : f
  );

  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}